<template>
  <div>
    <FloatingCartBox
      v-if="currentProject && currentProject.id && cartSettings && cartSettings.cart_enabled && !locked(currentProject)"
      :currentProject="currentProject"
      :totalIncentive="totalIncentive"
      :pageConfiguration="pageConfiguration"
    />
    <div class="row">
      <div class="col-12">
        <div :class="['content-box', { 'no-card': disableCard }]">
          <div :class="['card-body', { 'no-card': disableCard }]">
            <div class="m-2 pl-3 text-center" v-if="isLoading">
              <font-awesome-icon
                :icon="['fa', 'circle-notch']"
                class="fa-spin m-auto spinner fa-5x egx-partner-color"
              />
            </div>
            <div v-else>
              <span class="egx-partner-color">
                <h2 v-safe-html="applicationDetail.title" v-if="applicationDetail.title"/>
              </span>
              <div v-safe-html="parsedMainInstructions" style="color: #6e7177;" v-if="applicationDetail.main_instructions"/>
              <div v-for="group in sortedGroups" :key="group.sort_order" class="mt-4">
                <applicationDetails :group="group"/>
              </div>
              <div class="w-100 d-flex justify-content-center align-items-center">
                <button class="btn btn-egx" @click="returnToMyApplications()">
                  Return to My Applications Page
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationDetails from '../components/ApplicationDetails.vue';
import projectMixins from '@/shared/mixins/projectMixins';
import FloatingCartBox from '../components/FloatingCartBox.vue';

export default {
  components: {
    ApplicationDetails,
    FloatingCartBox,
  },
  mixins: [projectMixins],
  data() {
    return {
      disableCard: false,
      applicationDetail: [],
      isLoading: false,
      totalIncentive: null,
      pageConfiguration: {},
    };
  },

  computed: {
    sortedGroups() {
      return this.applicationDetail.groups.sort((a, b) => a.sort_order - b.sort_order);
    },
    parsedMainInstructions() {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.applicationDetail.main_instructions, 'text/html');
      const images = doc.querySelectorAll('img');
      images.forEach(img => {
        const newImg = document.createElement('img');
        newImg.src = img.src;
        newImg.alt = img.alt;
        img.replaceWith(newImg);
      });
      return doc.body.innerHTML || '';
    },
    currentProject() {
      return this.$store.state.fulfill_integrate.currentSelectedProject;
    },
    cartSettings() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details.settings.project_measures_cart || {};
    },
  },

  created() {
    this.isLoading = true;

    this.$store.commit('fulfill_integrate/clearProject');

    this.$store.dispatch('fulfill_integrate/getPageConfiguration', {
      task_name: 'measurecart',
      project_id: this.$route.params.id,
    })
    .then((response) => {
      this.pageConfiguration = response;
    })
    .catch((error) => {
      console.log(error);
    })
    this.$store.dispatch('fulfill_integrate/get_project_selected', { project_id: this.$route.params.id })
      .then((response) => {
        if(this.isNotUserProject(response.project)) {
          this.$router.push('/applications');
          return
        } else {
          this.$store.dispatch('fulfill_integrate/getProjectDetails', { project_id: this.$route.params.id })
            .then((response) => {
              console.log(response.project);
              this.applicationDetail = response.project;
              this.isLoading = false;
            }).catch((error) => {
            console.log(error)
          });
        }
      })
      .catch((error) => {
        this.isVisible = false;
        console.log(error);
      });
  },

  methods: {
    returnToMyApplications() {
      this.$router.push({ name: 'applicationsShowAll' });
    },
  },
}
</script>
